import { usePagination } from 'react-instantsearch';

import Pagination from './Pagination';

export default function AlgoliaPagination() {
  const {
    currentRefinement,
    nbPages,
    isFirstPage,
    isLastPage,
    canRefine,
    refine,
  } = usePagination();

  if (!canRefine) {
    return null;
  }

  return (
    <Pagination
      currentPage={currentRefinement + 1}
      totalPages={nbPages}
      hasPrevPage={!isFirstPage && nbPages > 1}
      hasNextPage={!isLastPage && nbPages > 1}
      handlePrevPage={() => refine(currentRefinement - 1)}
      handleNextPage={() => refine(currentRefinement + 1)}
      handleGoToPage={page => refine(page - 1)}
    />
  );
}
